import actionsTypes from './action-types'

export const ProfilesLoaded = (profiles, fileGuid, fileName) => {
  return (dispatch, getState) => {
    return dispatch({
      type: actionsTypes.PROFILES_LOADED,
      profiles: profiles,
      fileGuid: fileGuid,
      fileName: fileName
    });
  };
}

export const ProfileSelected = (profile, checked) => {
  return {
    type: actionsTypes.SELECTED_PROFILE,
    profileId: profile.profileId,
    checked: checked
  };
}



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/store/actions.js